var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "animated fadeIn" }, [
    _c("div", { staticClass: "row no-gutters mb-3" }, [
      _c("div", { staticClass: "col-12 col-md-6 mb-3 mb-md-0" }, [
        _c("div", { staticClass: "display-1 my-auto" }, [
          _vm._v(_vm._s(_vm.reportTitle()))
        ])
      ])
    ]),
    _vm._v(" "),
    _vm.hasUserList()
      ? _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12 col-lg-12" },
            [
              _c(
                "b-card",
                { class: _vm.widgetClasses(_vm.importUserInfo) },
                [
                  _c("dashboard-widget", {
                    attrs: {
                      widgetType: "block",
                      widgetInfo: _vm.importUserInfo
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "row no-gutters" }, [
      _c("div", { staticClass: "col-12 col-lg-6" }, [
        _c(
          "div",
          { staticClass: "mr-md-4 pb-3 rounded shadow-sm" },
          [
            _c(
              "b-card",
              { class: _vm.widgetClasses(_vm.uploadUsersInfo) },
              [
                _c("dashboard-widget", {
                  attrs: {
                    widgetType: "block",
                    widgetInfo: _vm.uploadUsersInfo
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-lg-6" }, [
        _c(
          "div",
          { staticClass: "ml-md-4 pb-3 rounded shadow-sm" },
          [
            _c(
              "b-card",
              { class: _vm.widgetClasses(_vm.downloadTemplateInfo) },
              [
                _c("dashboard-widget", {
                  attrs: {
                    widgetType: "block",
                    widgetInfo: _vm.downloadTemplateInfo
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("hr")
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73837f7f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73837f7f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/admin/user/ImportUsers.vue
// module id = null
// module chunks = 